import type {ReactElement} from 'react'
import {useLocation} from 'react-router'
import {isEqual} from 'lodash'
import {useSafeEffectExtraDeps} from '@freckle/react-hooks'

export function ScrollToTop({children}: {children: ReactElement}) {
  const location = useLocation()

  useSafeEffectExtraDeps(
    () => {
      window.scrollTo(0, 0)
    },
    [],
    {
      pathname: {value: location.pathname, comparator: isEqual}
    }
  )

  return children
}
